"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatorGuard = calculatorGuard;
const app_1 = require("@kalkulacka-one/app");
const navigation_1 = require("next/navigation");
const calculator_path_1 = require("./calculator-path");
async function calculatorGuard({ endpoint, key, group, prefixed }) {
    try {
        const calculator = await (0, app_1.loadCalculator)({ endpoint, key, group });
        (0, calculator_path_1.calculatorPathGuard)({ calculator, prefixed, group });
    }
    catch (error) {
        if (error instanceof app_1.NotFoundError) {
            (0, navigation_1.notFound)();
        }
        throw error;
    }
}
